import { Navigate, useLocation } from "react-router-dom";

import {
  HCBB_COST_ESTIMATOR_RESULT_PATH,
  readHcbbProfessionalState,
} from "@/lib/hcbb-cost-estimator-utils";
import { HcbbBackButton } from "@/pages/components/hcbb-cost-estimator/hcbb-back-button";
import { HcbbProviderSummary } from "@/pages/components/hcbb-cost-estimator/hcbb-provider-summary";
import PageContainer from "@/pages/containers/page-container";

/**
 * One provider from the cost estimate, opened from their result row.
 *
 * Same contract as the facility screen: the row arrives in router state, and a
 * URL opened without one returns to the results. The state is read from its
 * own key, so a facility pushed by the other button cannot land here.
 */
export const HcbbProviderDetailPage = () => {
  const { state, search } = useLocation();
  const professional = readHcbbProfessionalState(state);

  if (!professional) {
    return (
      <Navigate
        to={{ pathname: HCBB_COST_ESTIMATOR_RESULT_PATH, search }}
        replace
      />
    );
  }

  return (
    <PageContainer
      headerLeftContent={
        <HcbbBackButton label="Back to cost estimate results" />
      }
      title="Provider Details"
    >
      <div className="p-6">
        <HcbbProviderSummary professional={professional} />
      </div>
    </PageContainer>
  );
};
